import { useState } from 'react'

import { Heading6 } from '~/theme/utils/typography'

import { PresaleContainer, PresaleInputContainer } from '~/components/Restaurant/PresaleCodeInput/PresaleCodeInputShards'
import { gt } from '~/locale'
import Button from '~/shared/atoms/Button'
import Input from '~/shared/atoms/Input'

type PresaleCodeInputViewProps = {
  onSubmit: (newPresaleCode: string) => void
  value?: string
}

export const PresaleCodeInputView = ({ value, onSubmit }: PresaleCodeInputViewProps) => {
  const [code, setCode] = useState(value || '')

  return (
    <PresaleContainer>
      <Heading6>{gt.tp('SlotSelection', 'Enter early reservation code or code received in the Magenta Moments Program.')}</Heading6>
      <PresaleInputContainer>
        <Input height={'normal'} width={'full'} onChange={event => setCode(event.target.value)} disabled={!!value} />
        <Button
          label={value ? gt.tp('SlotSelection', 'Edit') : gt.tp('SlotSelection', 'Confirm')}
          color='orange'
          onClick={() => {
            onSubmit(value ? '' : code)
          }}
        />
      </PresaleInputContainer>
    </PresaleContainer>
  )
}
